import React, { useContext, useEffect } from 'react'
import { Modal, Card, Box, Typography, CardHeader, CardContent, Rating, Grid } from '@mui/material'
import { IconBtn, Loading } from '../../Simple'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { FaStar } from 'react-icons/fa'
import CloseIcon from '@mui/icons-material/Close'
import moment from 'moment'

export default function AvaliacoesCentroEsportivo({ open, onClose, width = 500, height = 'auto' }) {
  const { sttPg, actionsCtxEmps, loads } = useContext(EmpresasContext)

  useEffect(() => {
    sttPg.paginationAvaliacoes.offset === 0 && actionsCtxEmps.BuscarAvaliacoesEmpresa(sttPg.empresa.idempresa)
    if (document.querySelector('#bottomTable')) {
      const intersectionObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          actionsCtxEmps.BuscarAvaliacoesEmpresa(sttPg.empresa.idempresa)
        }
      })
      intersectionObserver.observe(document.querySelector('#bottomTable'))
      return () => intersectionObserver.disconnect()
    }
  }, [sttPg.empresa.idempresa, sttPg.paginationAvaliacoes.offset])

  return (
    <Modal open={open} onClose={onClose} sx={stMd.containModal}>
      <Card sx={{ ...stMd.containModalCard, height: loads.avaliacao ? '90vh' : height, width: width }}>
        <CardHeader
          position='sticky'
          top={0}
          action={<IconBtn onClick={() => onClose()} Icon={CloseIcon} title='Fechar' />}
          title={
            <Typography variant='h5' fontWeight='bold'>
              Avaliações
            </Typography>
          }
        />

        <CardContent sx={stMd.containModalCardContent}>
          {loads.avaliacao ? (
            <div className='contain-loading'>
              <Loading text={'Carregando avaliações...'} />
            </div>
          ) : (
            <>
              {/* Avaliação geral */}
              <Typography variant='h5' sx={{ fontFamily: 'jost-mediun' }}>
                {parseFloat(sttPg?.avaliacao?.medias?.mediaNotaGeral).toFixed(1).replace('.', ',')}
              </Typography>
              <Rating
                readOnly
                sx={{ gap: '3px' }}
                precision={1}
                icon={<FaStar size={18} />}
                emptyIcon={<FaStar size={18} />}
                value={parseFloat(parseFloat(sttPg?.avaliacao?.medias?.mediaNotaGeral).toFixed(0))}
              />
              <Grid container rowSpacing={0} sx={stMd.containMediasAvs}>
                <Grid item xs={10}>
                  <Typography variant='body2'>Materiais</Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='body2' textAlign={'right'}>
                    {parseFloat(sttPg?.avaliacao?.medias?.mediaQualidadaMateriais).toFixed(1).replace('.', ',')}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant='body2'>Quadra e ambiente</Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='body2' textAlign={'right'}>
                    {parseFloat(sttPg?.avaliacao?.medias?.mediaQualidadeLocal).toFixed(1).replace('.', ',')}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography variant='body2'>Tempo de resposta</Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant='body2' textAlign={'right'}>
                    {parseFloat(sttPg?.avaliacao?.medias?.mediaTempo).toFixed(1).replace('.', ',')}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography variant='body1' marginTop={1} color='text.secondary'>
                  {`${sttPg?.avaliacao?.avaliacoes?.count} avaliações`}
                </Typography>
              </Grid>
              <Box sx={stMd.containListAvs}>
                {sttPg?.avaliacao?.avaliacoes?.rows.map((av, index) => (
                  <React.Fragment key={index}>
                    <Box sx={stMd.containCompAv}>
                      <Box sx={stMd.containLeft}>
                        <Box sx={stMd.containAvs}>
                          <Typography variant='body2' fontWeight='bold' marginRight={1}>
                            {av.notaGeral.toFixed(1).replace('.', ',')}
                          </Typography>
                          <Rating
                            readOnly
                            precision={0.2}
                            sx={{ gap: '3px' }}
                            value={parseFloat(parseFloat(av.notaGeral).toFixed(1))}
                            icon={<FaStar size={18} />}
                            emptyIcon={<FaStar size={18} />}
                          />
                        </Box>
                        <Typography variant='body2' color='text.secondary' sx={{ fontWeight: 'bold', fontFamily: 'jost-mediun' }}>
                          {av.nome}
                        </Typography>
                        <Typography variant='body2' color='text.secondary' sx={{ color: 'gray' }}>
                          {av.texto}
                        </Typography>
                      </Box>
                      <Box sx={stMd.containRight}>
                        <Typography
                          variant='caption'
                          sx={{
                            whiteSpace: 'nowrap',
                            color: 'gray',
                            fontFamily: 'jost-light',
                            fontWeight: 'bold',
                          }}
                        >
                          {moment(av.createdAt).format('DD [de] MMM [de] YYYY')}
                        </Typography>
                      </Box>
                    </Box>
                  </React.Fragment>
                ))}
                <div id='bottomTable' className='tw-h-2' />
                {sttPg.paginationAvaliacoes.offset < sttPg.avaliacao.avaliacoes?.count && <Loading />}
              </Box>
            </>
          )}
        </CardContent>
      </Card>
    </Modal>
  )
}

const stMd = {
  containModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containModalCard: {
    bgcolor: 'background.paper',
    maxHeight: '90vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    borderRadius: 3,
  },
  containModalCardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'calc(100% - 64px)',
    overflowY: 'auto',
  },
  containMediasAvs: {
    padding: '10px',
    backgroundColor: '#f9f9f9',
    borderRadius: '12px',
    marginTop: '10px',
  },
  containListAvs: {
    width: '100%',
    overflow: 'auto',
  },
  containCompAv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '10px',
    height: 'auto',
    width: '100%',
    backgroundColor: '#f9f9f9',
    borderRadius: '12px',
    marginBottom: '5px',
  },
  containLeft: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: 'auto',
    width: '80%',
  },
  containAvs: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
  },
  containRight: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    height: '100%',
    width: 'auto',
  },
}
